import { Box, IconButton } from '@mui/material';
import React from 'react';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';

const iconMap = {
    facebook: FacebookIcon,
    instagram: InstagramIcon,
    twitter: XIcon,
    linkedin: LinkedInIcon,
    youtube: YouTubeIcon,
};

const Social = ({ data }) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            {Object.entries(data || {}).map(([key, url]) => {
                if (!url) return null;
                const Icon = iconMap[key.toLowerCase()];
                if (!Icon) return null;
                return (
                    <IconButton
                        key={key}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            color: '#A0AEC0', // Light gray color for the filled icons
                            p: 0.5, // minimal padding so the icon itself takes up most of the space
                            transition: 'all 0.3s',
                            '&:hover': { 
                                color: '#5EB0FF', 
                                transform: 'translateY(-2px)' 
                            },
                        }}
                        size="small"
                    >
                        <Icon sx={{ fontSize: 28 }} />
                    </IconButton>
                );
            })}
        </Box>
    );
};

export default Social;
